import { EdgeCreateProCrewRepository } from '@/modules/auth/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { CreateProCrew } from '@/modules/auth/use-cases'

export function makeCreateProCrew(): CreateProCrew {
  return new EdgeCreateProCrewRepository(makeSupabaseEdgeHttpClient()).execute
}
